module.exports = __webpack_public_path__ + "static/img/join_hover.e88481cd.svg";